import styled from 'styled-components'
import { t } from 'ttag'

import { SG, SG90T } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Flex } from '@h2/components/layout/flex'

const Wrap = styled.div`
  background-color: ${SG90T};
  padding: 10px 20px 20px;
  border-radius: 5px;
  margin-top: 15px;
  border: solid ${SG} 1px;

  > :nth-child(2) {
    gap: 10px;
  }
`
const ThingsToAction = ({ children }) => (
  <Wrap>
    <Flex margin="0 0 5px 0">
      <Heading level="5" removeMargins={true}>
        {t`Things to `}
        <strong>{t`action`}</strong>
      </Heading>
    </Flex>
    <Flex justifyContent="space-between">{children}</Flex>
  </Wrap>
)

ThingsToAction.propTypes = {}

export { ThingsToAction }
